import { isExternal } from "@root/utiles/validate.ts";
function getFirst(arry, label) {
  if (!arry.length) return null;
  if (arry[0] && arry[0][label] && arry[0][label].length) {
    return getFirst(arry[0][label], label);
  } else {
    const isExternalUrl = urlItem => {
      return !!isExternal(urlItem["pageUrl"]);
    };
    for (let i = 0; i < arry.length; i++) {
      // if (!isExternalUrl(arry[i])) return arry[i];
      let menuItem: any = arry[i];
      if (!isExternalUrl(menuItem)) {
        if (menuItem && menuItem[label] && menuItem[label].length) {
          return getFirst(menuItem[label], label);
        } else if (menuItem["pageUrl"] && menuItem["pageUrl"] != "qipei") {
          return menuItem;
        }
      }
    }
  }
}
function getFirstMenu() {
  let menuStr = localStorage.getItem("menuList") || "[]",
    mentList = JSON.parse(menuStr);
  return getFirst(mentList, "children");
}
export default function (router) {
  console.log("addRoute");
  let menuStr = localStorage.getItem("menuList") || "[]",
    mentList = JSON.parse(menuStr);
  let data = getFirst(mentList, "children");
  data &&
    router.addRoutes([
      {
        path: "/",
        name: "TransferPage",
        redirect: data.pageUrl
      }
    ]);
}

export { getFirst, getFirstMenu };
